// axios
import axios, { AxiosError, AxiosResponse } from 'axios';
import { STATUS_CODE } from '@/constants/api';
import store from '@/store';
import router from '@/router';
import { OutStatus } from '@/constants/constants';
import { API_UPLOAD_FILE } from '@/constants/api';

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_BFF_BASEURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// リクエストヘッダーに、tokenをセットする
if (sessionStorage.getItem('Authorization')) {
  axiosIns.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem(
    'Authorization'
  )}`;
}

// 200ステータスコード以外バイパスURLをここに追加
const urlExcepts = [API_UPLOAD_FILE];

axiosIns.interceptors.request.use((request) => {
  const programId = sessionStorage.getItem('ProgramId');
  const riyoshaCd = sessionStorage.getItem('RiyoshaCd');
  const genzaiYmd = sessionStorage.getItem('GenzaiYmd');
  if (!request.params) {
    request.params = {};
  }
  request.params.programId =
    programId === null ? programId : programId.substring(0, 9);
  request.params.riyoshaCd = riyoshaCd;
  request.params.genzaiYmd = genzaiYmd;
  return request;
});

// レスポンス受信後の処理
axiosIns.interceptors.response.use(
  (response: AxiosResponse) => {
    const status = response.status;
    const error = response.data.error;
    if (error && error.outStatus !== OutStatus.NORMAL) {
      if (
        error.outStatus === OutStatus.GENZAI_YMD_CHECK_ERR ||
        error.outStatus === OutStatus.ONLINE_CHECK_ERR
      ) {
        store.dispatch('common/setMessage', { status, error });
        router.push('/location');
      }
    }
    return response;
  },
  (err: AxiosError) => {
    if (!err.response) {
      return;
    }
    if (
      err &&
      err.response &&
      err.response.config &&
      err.response.config.url &&
      urlExcepts.includes(err.response.config.url)
    ) {
      return err.response;
    }
    const status = err.response.status;
    const error = err.response.data.error; // エラー情報を登録
    store.dispatch('common/setMessage', { status, error });
    if (status === STATUS_CODE.UNAUTHORIZED) {
      sessionStorage.clear();
      router.push('/login', () => {});
    } else {
      router.push('/system-error');
    }
  }
);

export default axiosIns;
